@if (!errorDeletingUser) {
	<div class="pop-up-dialog-v2" [ngClass]="{ 'pop-up-dialog-confirmed-v2': step === 1 }">
		@if (step === 0) {
			<h3 i18n="@@deactivateUser-deactivateUserHeader">Deactivate User</h3>
		}
		@if (step === 1) {
			<h3 i18n="@@deactivateUser-userDeactivatedHeader">User Deactivated</h3>
		}
		<mat-divider></mat-divider>
		@if (step === 1) {
			<div class="check-icon-container">
				<mat-icon svgIcon="sl-check" class="check-icon"></mat-icon>
			</div>
		}
		@if (step === 0) {
			<mat-dialog-content>
				@if (!data.openFromUserPage) {
					<div>
						<ng-container i18n="@@deactivateUser-pleaseConfirm">Please confirm you want to deactivate</ng-container
						><ng-container>&nbsp;</ng-container>
						<span [ngPlural]="data.users.length"
							>({{ data.users.length }})
							<ng-template i18n="@@deactivateUser-userLowerCase" ngPluralCase="=1">user</ng-template
							><ng-container>&nbsp;</ng-container>
							<ng-template i18n="@@deactivateUser-usersLowerCase" ngPluralCase="other">users</ng-template
							><ng-container>&nbsp;</ng-container>
						</span>
						<ng-container>&nbsp;</ng-container><ng-container i18n="@@deactivateUser-from">from</ng-container
						><ng-container>&nbsp;</ng-container> <b>{{ data.roleName }}</b
						>.
						<span [ngPlural]="data.users.length">
							<ng-template i18n="@@deactivateUser-userUpperCase" ngPluralCase="=1">User</ng-template
							><ng-container>&nbsp;</ng-container>
							<ng-template i18n="@@deactivateUser-usersUpperCase" ngPluralCase="other">Users</ng-template
							><ng-container>&nbsp;</ng-container>
						</span>
						<ng-container i18n="@@deactivateUser-beingRemoved">being removed will be made inactive from</ng-container
						><ng-container>&nbsp;</ng-container> <b>{{ data.company.name }}</b
						>.
					</div>
				}
				@if (data.openFromUserPage) {
					<div>
						<ng-container i18n="@@deactivateUser-pleaseConfirm2">Please confirm you want to deactivate</ng-container
						><ng-container>&nbsp;</ng-container> <b>{{ listOfUserNames }}</b> <ng-container>&nbsp;</ng-container
						><ng-container i18n="@@deactivateUser-from2">from</ng-container><ng-container>&nbsp;</ng-container>
						<b>{{ data.company.name }}</b
						>.
					</div>
				}
			</mat-dialog-content>
		}
		@if (step === 1) {
			<mat-dialog-content>
				@if (!data.openFromUserPage) {
					<div>
						<ng-container i18n="@@deactivateUser-haveDeactivated">You have successfully deactivated</ng-container
						><ng-container>&nbsp;</ng-container>
						<span [ngPlural]="data.users.length"
							>({{ data.users.length }})
							<ng-template i18n="@@deactivateUser-userLowerCase2" ngPluralCase="=1">user</ng-template
							><ng-container>&nbsp;</ng-container>
							<ng-template i18n="@@deactivateUser-usersLowerCase2" ngPluralCase="other">users</ng-template
							><ng-container>&nbsp;</ng-container>
						</span>
						<ng-container>&nbsp;</ng-container><ng-container i18n="@@deactivateUser-from2">from</ng-container
						><ng-container>&nbsp;</ng-container> <b>{{ data.roleName }}</b
						>.
						<ng-container i18n="@@deactivateUser-nowInactive"
							>They are now inactive and no longer associated with</ng-container
						><ng-container>&nbsp;</ng-container> <b>{{ data.company.name }}</b
						>.
					</div>
				}
				@if (data.openFromUserPage) {
					<div>
						{{ listOfUserNames }}
						<ng-container i18n="@@deactivateUser-successfullyDeactivated"
							>has been successfully deactivated as a</ng-container
						><ng-container>&nbsp;</ng-container> <b>{{ data.roleName }}</b
						>.
						<ng-container i18n="@@deactivateUser-nowInactive2"
							>They are now inactive and no longer associated with</ng-container
						><ng-container>&nbsp;</ng-container> <b>{{ data.company.name }}</b
						>.
					</div>
				}
			</mat-dialog-content>
		}
		@if (step === 0) {
			<mat-dialog-actions>
				<button
					(click)="onCloseClicked(false)"
					class="secondary-small-button"
					i18n="@@deactivateUser-deactivateUserDialogCancel"
					data-automation-id="deactivate-user-cancel-button"
				>
					Cancel
				</button>
				<button
					(click)="onRemoveClicked()"
					class="primary-small-button"
					i18n="@@deactivateUser-deactivateUserDialogConfirm"
					data-automation-id="deactivate-user-confirm-button"
				>
					Confirm
				</button>
			</mat-dialog-actions>
		}
		@if (step === 1) {
			<mat-dialog-actions>
				<button
					(click)="onCloseClicked(true)"
					class="primary-small-button"
					i18n="@@deactivateUser-deactivateUserDialogClose"
					data-automation-id="deactivate-user-close-button"
				>
					Close
				</button>
			</mat-dialog-actions>
		}
	</div>
}

@if (errorDeletingUser) {
	<div class="pop-up-dialog-v2">
		<h3 i18n="@@deactivateUser-errorDeletingUserHeader">Error!</h3>
		<mat-divider></mat-divider>
		<mat-dialog-content>
			<div>
				<ng-container i18n="@@deactivateUser-unableDelete">Unable to delete the</ng-container
				><ng-container>&nbsp;</ng-container>
				<span [ngPlural]="data.users.length">
					<ng-template i18n="@@deactivateUser-userLowerCase3" ngPluralCase="=1">user</ng-template
					><ng-container>&nbsp;</ng-container>
					<ng-template i18n="@@deactivateUser-usersLowerCase3" ngPluralCase="other">users</ng-template
					><ng-container>&nbsp;</ng-container>
				</span>
				<ng-container i18n="@@deactivateUser-tryAgin">at this time. Please try again.</ng-container>
			</div>
		</mat-dialog-content>
		<mat-dialog-actions>
			<button
				(click)="onCloseClicked(false)"
				class="primary-small-button"
				i18n="@@deactivateUser-errorDeletingUserConfirm"
				data-automation-id="deactivate-user-ok-button"
			>
				Ok
			</button>
		</mat-dialog-actions>
	</div>
}
